/**
 * FollowUpTab Component
 * TASK-397: Post-Meeting Tabbed Redesign
 *
 * Email draft generation + CRM sync.
 * Reuses CRMSyncPanel from PostMeetingHub.
 */

import React from 'react';
import CRMSyncPanel from '../PostMeetingHub/CRMSyncPanel';
import type { Task } from '../../../types/meeting';

// ============================================================================
// Types
// ============================================================================

interface FollowUpTabProps {
  sessionId: string;
  clientName: string;
  clientEmail: string;
  meetingSummary: string;
  durationLabel: string;
  complianceScorePct: number | null;
  clientMood: string | null;
  tasksCount: number;
  keyTopicsCount: number | null;
  tasks: Task[];
  meetingType?: string;
  onSendFollowUp: (email: string, subject: string, body: string) => Promise<void>;
  onSyncCRM: () => void;
  onFinish: () => void;
}

// ============================================================================
// Component
// ============================================================================

const FollowUpTab: React.FC<FollowUpTabProps> = ({
  sessionId,
  clientName,
  clientEmail,
  meetingSummary,
  durationLabel,
  complianceScorePct,
  clientMood,
  tasksCount,
  keyTopicsCount,
  tasks,
  meetingType,
  onSendFollowUp,
  onSyncCRM,
  onFinish,
}) => {
  return (
    <div className="h-full overflow-y-auto p-6">
      <CRMSyncPanel
        onSendFollowUp={onSendFollowUp}
        onSyncCRM={onSyncCRM}
        onFinish={onFinish}
        sessionId={sessionId}
        clientName={clientName}
        clientEmail={clientEmail}
        meetingSummary={meetingSummary}
        durationLabel={durationLabel}
        complianceScorePct={complianceScorePct}
        clientMood={clientMood}
        tasksCount={tasksCount}
        keyTopicsCount={keyTopicsCount}
        tasks={tasks}
        meetingType={meetingType}
      />
    </div>
  );
};

export default FollowUpTab;
